import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'bt-all-is-approved-modal',
	standalone: false,
	templateUrl: './all-is-approved-modal.component.html',
	styleUrl: './all-is-approved-modal.component.scss'
})
export class AllIsApprovedModalComponent {
	data = inject<any>(MAT_DIALOG_DATA);

	constructor(private dialogRef: MatDialogRef<AllIsApprovedModalComponent>) {}

	close(confirm: boolean = false): void {
		this.dialogRef.close(confirm);
	}
}
